import { render, staticRenderFns } from "./CreateMember.vue?vue&type=template&id=68d4a19f&"
import script from "./CreateMember.vue?vue&type=script&lang=js&"
export * from "./CreateMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports